function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 19.5H1.5C1.23478 19.5 0.980383 19.3946 0.792847 19.2071C0.60531 19.0196 0.5 18.7652 0.5 18.5V1.71002C0.5 1.55112 0.531355 1.39375 0.592163 1.24695C0.652971 1.10014 0.742011 0.96679 0.85437 0.854431C0.966729 0.742072 1.10014 0.65291 1.24695 0.592102C1.39375 0.531294 1.55106 0.5 1.70996 0.5H22.29C22.4489 0.5 22.6062 0.531294 22.7531 0.592102C22.8999 0.65291 23.0333 0.742072 23.1456 0.854431C23.258 0.96679 23.347 1.10014 23.4078 1.24695C23.4686 1.39375 23.5 1.55112 23.5 1.71002V18.5C23.5 18.7652 23.3947 19.0196 23.2072 19.2071C23.0196 19.3946 22.7652 19.5 22.5 19.5Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 5.5H23.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 3C3.5 3.27614 3.27614 3.5 3 3.5C2.72386 3.5 2.5 3.27614 2.5 3C2.5 2.72386 2.72386 2.5 3 2.5C3.27614 2.5 3.5 2.72386 3.5 3Z",
  fill: "#828282",
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 3C6.5 3.27614 6.27614 3.5 6 3.5C5.72386 3.5 5.5 3.27614 5.5 3C5.5 2.72386 5.72386 2.5 6 2.5C6.27614 2.5 6.5 2.72386 6.5 3Z",
  fill: "#828282",
  stroke: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 3C9.5 3.27614 9.27614 3.5 9 3.5C8.72386 3.5 8.5 3.27614 8.5 3C8.5 2.72386 8.72386 2.5 9 2.5C9.27614 2.5 9.5 2.72386 9.5 3Z",
  fill: "#828282",
  stroke: "currentColor"
});

var SvgNewPosts = function SvgNewPosts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewPosts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new_posts.aebc8895.svg";
export { ForwardRef as ReactComponent };